import { render, staticRenderFns } from "./imgborder.vue?vue&type=template&id=1d0118c8&"
import script from "./imgborder.vue?vue&type=script&lang=js&"
export * from "./imgborder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports